"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SummaryDataChangedEvent = void 0;
const api_external_contract_js_1 = require("@tableau/api-external-contract-js");
const TableauWorksheetEvent_1 = require("./TableauWorksheetEvent");
class SummaryDataChangedEvent extends TableauWorksheetEvent_1.TableauWorksheetEvent {
    constructor(worksheet) {
        super(api_external_contract_js_1.TableauEventType.SummaryDataChanged, worksheet);
    }
}
exports.SummaryDataChangedEvent = SummaryDataChangedEvent;
//# sourceMappingURL=SummaryDataChangedEvent.js.map